import { api } from "./client";

export function ensureMaya({ signal } = {}) { return api("/api/aicmo/ensure", { method: "POST", signal, json: {} }); }
export function getMayaHistory({ signal } = {}) { return api("/api/aicmo/history", { signal }); }
export function logMayaMessage(role, content, brand, { signal } = {}) { return api("/api/aicmo/log", { method: "POST", signal, json: { role, content, brand } }); }
export function runMayaSkill(payload, { signal } = {}) { return api("/api/aicmo/skill", { method: "POST", signal, json: payload }); }
export function getMayaSkillStatus(job, { signal } = {}) { return api(`/api/aicmo/skill/status?job=${encodeURIComponent(job)}`, { signal }); }

export function uploadMayaAttachment(file, { signal } = {}) {
  const form = new FormData();
  form.append("file", file, file.name);
  return api("/api/aicmo/upload", { method: "POST", body: form, signal });
}

// GEO_EXEC_R19 · the unread badge the sidebar polls, and the switch that says whether to poll.
// `getR19Features` 404s while the switch is off, which is how the front end learns R19 is not
// deployed without a second feature-flag system existing anywhere.
export function getMayaUnread({ signal } = {}) { return api("/api/aicmo/unread", { signal }); }
export function getR19Features({ signal } = {}) { return api("/api/geo-exec/r19/features", { signal }); }
